(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-new-3"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 防止 JS 被重复执行时多次注册监听器
  if (window.__bogoSelectModalInit) return;
  window.__bogoSelectModalInit = true;

  var bogoAddQueue = [];
  var bogoQueueRunning = false;
  var bogoLastAddAt = 0;
  var bogoRefreshTimer = null;
  var bogoCartNeedsRefresh = false;
  var BOGO_ADD_GAP = 3000;
  var BOGO_REFRESH_DELAY = 4000;
  var BOGO_RATE_LIMIT_WAIT = 4000;

  // 带重试的 fetch，应对第三方插件打满 API 速率限制导致的 429
  function fetchWithRetry(url, opts, retriesLeft) {
    retriesLeft = retriesLeft === undefined ? 4 : retriesLeft;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(fetchWithRetry(url, opts, retriesLeft - 1));
          }, 2000 * (5 - retriesLeft));
        });
      }
      return r;
    });
  }

  function addBogoVariantToCart(variantId) {
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function (r) {
      if (r.status === 429) return 'rate_limited';
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function runBogoAddQueue() {
    if (bogoQueueRunning || !bogoAddQueue.length) return;
    bogoQueueRunning = true;

    var gapWait = Math.max(0, BOGO_ADD_GAP - (Date.now() - bogoLastAddAt));
    setTimeout(function () {
      var job = bogoAddQueue.shift();
      if (!job) {
        bogoQueueRunning = false;
        return;
      }

      var btn = job.btn;
      var origText = job.origText;
      btn.textContent = '...';

      addBogoVariantToCart(job.variantId)
        .then(function (result) {
          if (result === 'rate_limited') {
            bogoAddQueue.unshift(job);
            btn.textContent = 'Wait...';
            return false;
          }
          updateBogoProgressByCount(getCurrentBogoCount() + 1);
          bogoCartNeedsRefresh = true;
          btn.textContent = '✓ ADDED';
          delete btn.dataset.bogoQueued;
          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
          return true;
        })
        .catch(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.bogoQueued;
        })
        .finally(function () {
          bogoLastAddAt = Date.now();
          bogoQueueRunning = false;
          var nextDelay = btn.textContent === 'Wait...' ? BOGO_RATE_LIMIT_WAIT : 0;
          setTimeout(function () {
            runBogoAddQueue();
            tryRefreshCartWhenIdle();
          }, nextDelay);
        });
    }, gapWait);
  }

  // 等队列全部处理完再刷新购物车，避免每件商品加购都触发 refresh 和插件抢 API
  function tryRefreshCartWhenIdle() {
    if (!bogoCartNeedsRefresh || bogoQueueRunning || bogoAddQueue.length > 0) return;
    if (bogoRefreshTimer) clearTimeout(bogoRefreshTimer);
    bogoRefreshTimer = setTimeout(function () {
      bogoRefreshTimer = null;
      bogoCartNeedsRefresh = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, BOGO_REFRESH_DELAY);
  }

  function getChosenOptions(form) {
    var result = [];
    var maxPos = 0;
    form.querySelectorAll('select[name^="option"]').forEach(function (el) {
      var pos = parseInt(el.name.replace('option', ''), 10);
      if (pos > maxPos) maxPos = pos;
    });
    for (var i = 1; i <= maxPos; i++) {
      var el = form.querySelector('[name="option' + i + '"]');
      result.push(el ? el.value : null);
    }
    return result;
  }

  var bogoMoneyFormatter = null;

  function formatBogoMoney(cents) {
    if (typeof Shopify !== 'undefined') {
      if (!bogoMoneyFormatter) {
        bogoMoneyFormatter = new Intl.NumberFormat(Shopify.locale || 'en-US', {
          style: 'currency',
          currency: Shopify.currency.active
        });
      }
      return bogoMoneyFormatter.format(cents / 100);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function bogoVariantImageUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url = url.split('?')[0] + '?width=200';
    }
    return url;
  }

  function getMediaPreviewSrc(media) {
    if (!media || !media.preview_image) return '';
    return media.preview_image.src || media.preview_image.url || '';
  }

  function getBogoVariantImageSrc(variant) {
    if (!variant) return '';
    var fromMedia = getMediaPreviewSrc(variant.featured_media);
    if (fromMedia) return fromMedia;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return '';
  }

  function getBogoColorMediaSrc(form) {
    var colorSel = form.querySelector('.bogo-color-sel');
    if (!colorSel) return '';
    var opt = colorSel.options[colorSel.selectedIndex];
    if (!opt || !opt.dataset.variantMedia) return '';
    try {
      return getMediaPreviewSrc(JSON.parse(opt.dataset.variantMedia));
    } catch (e) {
      return '';
    }
  }

  function setBogoProductImage(img, rawSrc, defaultSrc) {
    var nextSrc = rawSrc ? bogoVariantImageUrl(rawSrc) : (defaultSrc || img.dataset.defaultSrc || img.getAttribute('src'));
    if (!nextSrc) return;
    var currentPath = img.src.split('?')[0];
    var nextPath = (nextSrc.indexOf('//') === 0 ? 'https:' + nextSrc : nextSrc).split('?')[0];
    if (currentPath === nextPath) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = nextSrc;
  }

  function updateBogoProductDisplay(form, match) {
    var productEl = form.closest('.bogo-modal-product');
    if (!productEl) return;

    var img = productEl.querySelector('.bogo-modal-product__img');
    if (img) {
      var rawSrc = getBogoVariantImageSrc(match) || getBogoColorMediaSrc(form);
      setBogoProductImage(img, rawSrc, img.dataset.defaultSrc);
    }

    var priceCurrent = productEl.querySelector('.bogo-modal-product__price-current');
    var priceCompare = productEl.querySelector('.bogo-modal-product__price-compare');
    if (!match || !priceCurrent) return;

    priceCurrent.textContent = formatBogoMoney(match.price);
    if (priceCompare) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceCompare.textContent = formatBogoMoney(match.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }
  }

  function updateVariant(form) {
    var variantsEl = form.querySelector('.bogo-variants-json');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var chosen = getChosenOptions(form);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length === chosen.length && v.options.every(function (opt, idx) { return opt === chosen[idx]; })) {
        match = v;
        break;
      }
    }
    var idInput = form.querySelector('.bogo-variant-id');
    var btn = form.querySelector('.bogo-modal-product__btn');
    if (match) {
      idInput.value = match.id;
      btn.disabled = !match.available;
    } else {
      btn.disabled = true;
    }
    updateBogoProductDisplay(form, match);
  }

  function initBogoProductForms() {
    document.querySelectorAll('#bogo-select-modal .bogo-product-form').forEach(function (form) {
      updateVariant(form);
    });
  }

  function updateColorDot(select) {
    var wrap = select.closest('.bogo-color-select-wrap');
    if (!wrap) return;
    var dot = wrap.querySelector('.bogo-color-dot');
    if (!dot) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var swatchStyle = opt.dataset.swatchStyle;
    if (swatchStyle) {
      dot.setAttribute('style', swatchStyle);
    }
  }

  function initColorDots() {
    document.querySelectorAll('.bogo-color-sel').forEach(function (sel) {
      updateColorDot(sel);
    });
  }

  initColorDots();

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'bogo-select-modal') {
      initColorDots();
      initBogoProductForms();
    }
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target.classList.contains('bogo-color-sel')) {
      updateColorDot(target);
    }
    if (target.classList.contains('bogo-option-select') || target.classList.contains('bogo-color-sel')) {
      var form = target.closest('.bogo-product-form');
      if (form) updateVariant(form);
    }
  });

  function getCurrentBogoCount() {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return 0;
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    if (!fill) return 0;
    var pct = parseInt(fill.style.width, 10) || 0;
    return pct >= 100 ? 2 : pct >= 50 ? 1 : 0;
  }

  function updateBogoProgressByCount(count) {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return;
    count = Math.min(Math.max(count, 0), 2);
    var pct = count === 0 ? 0 : count === 1 ? 50 : 100;
    var msg = modal.querySelector('[data-bogo-progress-msg]');
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    var gift = modal.querySelector('[data-bogo-progress-gift]');
    if (msg) {
      msg.innerHTML = count >= 2
        ? 'BOGO Unlocked! Cheaper item is <strong>FREE</strong>.'
        : 'Unlock BOGO, Add 1 more!';
    }
    if (fill) fill.style.width = pct + '%';
    if (gift) {
      gift.src = count >= 2 ? modal.dataset.giftAnim : modal.dataset.giftStatic;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bogo-modal-product__btn');
    if (!btn || btn.disabled || btn.dataset.bogoQueued === '1') return;
    var form = btn.closest('.bogo-product-form');
    if (!form) return;
    var variantId = form.querySelector('.bogo-variant-id').value;
    if (!variantId) return;

    btn.disabled = true;
    btn.dataset.bogoQueued = '1';
    var origText = btn.textContent.trim();
    btn.textContent = bogoQueueRunning || bogoAddQueue.length ? 'Queued' : '...';

    bogoAddQueue.push({ btn: btn, origText: origText, variantId: variantId });
    runBogoAddQueue();
  });

  function updateBogoProgress(items) {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return;
    var bogoIdsStr = (modal.dataset.bogoIds || '').replace(/\s/g, '');
    var bogoIds = {};
    bogoIdsStr.split(',').forEach(function (id) { if (id) bogoIds[id] = true; });
    var count = 0;
    items.forEach(function (item) {
      if (bogoIds[String(item.product_id)]) count += item.quantity;
    });
    count = Math.min(count, 2);
    var pct = count === 0 ? 0 : count === 1 ? 50 : 100;
    var msg = modal.querySelector('[data-bogo-progress-msg]');
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    var gift = modal.querySelector('[data-bogo-progress-gift]');
    if (msg) {
      msg.innerHTML = count >= 2
        ? 'BOGO Unlocked! Cheaper item is <strong>FREE</strong>.'
        : 'Unlock BOGO, Add 1 more!';
    }
    if (fill) fill.style.width = pct + '%';
    if (gift) {
      gift.src = count >= 2 ? modal.dataset.giftAnim : modal.dataset.giftStatic;
    }
  }

  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.items) {
      updateBogoProgress(e.detail.cart.items);
    }
  });

  try {
    var stored = JSON.parse(localStorage.getItem('theme:cart-items') || '[]');
    if (stored.length) updateBogoProgress(stored);
  } catch (err) {}
})();

(function () {
  if (window.__buy3GiftModalInit) return;
  window.__buy3GiftModalInit = true;

  var buy3AddQueue = [];
  var buy3QueueRunning = false;
  var buy3LastAddAt = 0;
  var buy3RefreshTimer = null;
  var buy3CartNeedsRefresh = false;
  var BUY3_ADD_GAP = 3000;
  var BUY3_REFRESH_DELAY = 4000;
  var BUY3_RATE_LIMIT_WAIT = 4000;
  var BUY3_PROMO = {
    type: 'buy3_gift',
    campaign: 'buy3_get1'
  };

  function fetchWithRetry(url, opts, retriesLeft) {
    retriesLeft = retriesLeft === undefined ? 4 : retriesLeft;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(fetchWithRetry(url, opts, retriesLeft - 1));
          }, 2000 * (5 - retriesLeft));
        });
      }
      return r;
    });
  }

  function addBuy3GiftToCart(variantId) {
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: {
          '_promo_type': BUY3_PROMO.type,
          '_promo_campaign': BUY3_PROMO.campaign
        }
      })
    }).then(function (r) {
      if (r.status === 429) return 'rate_limited';
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function tryRefreshCartWhenIdle() {
    if (!buy3CartNeedsRefresh || buy3QueueRunning || buy3AddQueue.length > 0) return;
    if (buy3RefreshTimer) clearTimeout(buy3RefreshTimer);
    buy3RefreshTimer = setTimeout(function () {
      buy3RefreshTimer = null;
      buy3CartNeedsRefresh = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, BUY3_REFRESH_DELAY);
  }

  function runBuy3AddQueue() {
    if (buy3QueueRunning || !buy3AddQueue.length) return;
    buy3QueueRunning = true;

    var gapWait = Math.max(0, BUY3_ADD_GAP - (Date.now() - buy3LastAddAt));
    setTimeout(function () {
      var job = buy3AddQueue.shift();
      if (!job) {
        buy3QueueRunning = false;
        return;
      }

      var btn = job.btn;
      var origText = job.origText;
      btn.textContent = '...';

      addBuy3GiftToCart(job.variantId)
        .then(function (result) {
          if (result === 'rate_limited') {
            buy3AddQueue.unshift(job);
            btn.textContent = 'Wait...';
            return false;
          }
          buy3CartNeedsRefresh = true;
          btn.textContent = '✓ ADDED';
          delete btn.dataset.buy3Queued;

          var modal = document.getElementById('buy3-gift-select-modal');
          if (modal && typeof modal.hide === 'function') {
            modal.hide();
          }

          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
          return true;
        })
        .catch(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.buy3Queued;
        })
        .finally(function () {
          buy3LastAddAt = Date.now();
          buy3QueueRunning = false;
          var nextDelay = btn.textContent === 'Wait...' ? BUY3_RATE_LIMIT_WAIT : 0;
          setTimeout(function () {
            runBuy3AddQueue();
            tryRefreshCartWhenIdle();
          }, nextDelay);
        });
    }, gapWait);
  }

  function getChosenOptions(form) {
    var result = [];
    var maxPos = 0;
    form.querySelectorAll('select[name^="option"]').forEach(function (el) {
      var pos = parseInt(el.name.replace('option', ''), 10);
      if (pos > maxPos) maxPos = pos;
    });
    for (var i = 1; i <= maxPos; i++) {
      var el = form.querySelector('[name="option' + i + '"]');
      result.push(el ? el.value : null);
    }
    return result;
  }

  var buy3MoneyFormatter = null;

  function formatBuy3Money(cents) {
    if (typeof Shopify !== 'undefined') {
      if (!buy3MoneyFormatter) {
        buy3MoneyFormatter = new Intl.NumberFormat(Shopify.locale || 'en-US', {
          style: 'currency',
          currency: Shopify.currency.active
        });
      }
      return buy3MoneyFormatter.format(cents / 100);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function buy3VariantImageUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url = url.split('?')[0] + '?width=200';
    }
    return url;
  }

  function getMediaPreviewSrc(media) {
    if (!media || !media.preview_image) return '';
    return media.preview_image.src || media.preview_image.url || '';
  }

  function getBuy3VariantImageSrc(variant) {
    if (!variant) return '';
    var fromMedia = getMediaPreviewSrc(variant.featured_media);
    if (fromMedia) return fromMedia;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return '';
  }

  function getBuy3ColorMediaSrc(form) {
    var colorSel = form.querySelector('.buy3-gift-color-sel');
    if (!colorSel) return '';
    var opt = colorSel.options[colorSel.selectedIndex];
    if (!opt || !opt.dataset.variantMedia) return '';
    try {
      return getMediaPreviewSrc(JSON.parse(opt.dataset.variantMedia));
    } catch (e) {
      return '';
    }
  }

  function setBuy3ProductImage(img, rawSrc, defaultSrc) {
    var nextSrc = rawSrc ? buy3VariantImageUrl(rawSrc) : (defaultSrc || img.dataset.defaultSrc || img.getAttribute('src'));
    if (!nextSrc) return;
    var currentPath = img.src.split('?')[0];
    var nextPath = (nextSrc.indexOf('//') === 0 ? 'https:' + nextSrc : nextSrc).split('?')[0];
    if (currentPath === nextPath) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = nextSrc;
  }

  function updateBuy3ProductDisplay(form, match) {
    var productEl = form.closest('.buy3-gift-modal-product');
    if (!productEl) return;

    var img = productEl.querySelector('.buy3-gift-modal-product__img');
    if (img) {
      var rawSrc = getBuy3VariantImageSrc(match) || getBuy3ColorMediaSrc(form);
      setBuy3ProductImage(img, rawSrc, img.dataset.defaultSrc);
    }

    var priceCurrent = productEl.querySelector('.buy3-gift-modal-product__price-current');
    var priceCompare = productEl.querySelector('.buy3-gift-modal-product__price-compare');
    if (!match || !priceCurrent) return;

    priceCurrent.textContent = formatBuy3Money(match.price);
    if (priceCompare) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceCompare.textContent = formatBuy3Money(match.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }
  }

  function updateBuy3Availability(form, isAvailable) {
    var btn = form.querySelector('.buy3-gift-modal-product__btn');
    var notice = form.querySelector('.buy3-gift-modal-product__sold-out-notice');
    if (!btn || btn.dataset.buy3Queued === '1') return;

    btn.disabled = !isAvailable;
    if (notice) {
      notice.hidden = !!isAvailable;
    }
  }

  function updateBuy3Variant(form) {
    var variantsEl = form.querySelector('.buy3-gift-variants-json');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var chosen = getChosenOptions(form);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length === chosen.length && v.options.every(function (opt, idx) { return opt === chosen[idx]; })) {
        match = v;
        break;
      }
    }
    var idInput = form.querySelector('.buy3-gift-variant-id');
    if (match) {
      idInput.value = match.id;
      updateBuy3Availability(form, !!match.available);
    } else {
      if (idInput) idInput.value = '';
      updateBuy3Availability(form, false);
    }
    updateBuy3ProductDisplay(form, match);
  }

  function initBuy3ProductForms() {
    document.querySelectorAll('#buy3-gift-select-modal .buy3-gift-product-form').forEach(function (form) {
      updateBuy3Variant(form);
    });
  }

  function updateBuy3ColorDot(select) {
    var wrap = select.closest('.buy3-gift-color-select-wrap');
    if (!wrap) return;
    var dot = wrap.querySelector('.buy3-gift-color-dot');
    if (!dot) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var swatchStyle = opt.dataset.swatchStyle;
    if (swatchStyle) {
      dot.setAttribute('style', swatchStyle);
    }
  }

  function initBuy3ColorDots() {
    document.querySelectorAll('.buy3-gift-color-sel').forEach(function (sel) {
      updateBuy3ColorDot(sel);
    });
  }

  initBuy3ColorDots();

  window.__fgGiftModalUI = {
    updateVariant: updateBuy3Variant,
    initColorDots: initBuy3ColorDots,
    initProductForms: function (rootSelector) {
      document.querySelectorAll((rootSelector || '#buy3-gift-select-modal') + ' .buy3-gift-product-form').forEach(function (form) {
        updateBuy3Variant(form);
      });
    }
  };

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'buy3-gift-select-modal') {
      initBuy3ColorDots();
      initBuy3ProductForms();
    }
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target.classList.contains('buy3-gift-color-sel')) {
      updateBuy3ColorDot(target);
    }
    if (target.classList.contains('buy3-gift-option-select') || target.classList.contains('buy3-gift-color-sel')) {
      var form = target.closest('.buy3-gift-product-form');
      if (form) updateBuy3Variant(form);
    }
  });

  document.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('#buy3-gift-select-modal .buy3-gift-modal-product__btn');
    if (chooseBtn && !chooseBtn.disabled && chooseBtn.dataset.buy3Queued !== '1') {
      var form = chooseBtn.closest('.buy3-gift-product-form');
      if (!form) return;
      var variantId = form.querySelector('.buy3-gift-variant-id').value;
      if (!variantId) return;

      chooseBtn.disabled = true;
      chooseBtn.dataset.buy3Queued = '1';
      var origText = chooseBtn.textContent.trim();
      chooseBtn.textContent = buy3QueueRunning || buy3AddQueue.length ? 'Queued' : '...';

      buy3AddQueue.push({ btn: chooseBtn, origText: origText, variantId: variantId });
      runBuy3AddQueue();
    }
  });
}());

(function () {
  if (window.__spendGiftInit) return;
  window.__spendGiftInit = true;

  var spendAddQueue = [];
  var spendQueueRunning = false;
  var spendLastAddAt = 0;
  var spendRefreshTimer = null;
  var spendCartNeedsRefresh = false;
  var spendRemoving = false;
  var SPEND_ADD_GAP = 3000;
  var SPEND_REFRESH_DELAY = 4000;
  var SPEND_RATE_LIMIT_WAIT = 4000;
  var SPEND_PROMO = {
    type: 'spend_gift',
    campaign: 'spend_threshold_gift'
  };

  function spendFetchWithRetry(url, opts, retriesLeft) {
    retriesLeft = retriesLeft === undefined ? 4 : retriesLeft;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(spendFetchWithRetry(url, opts, retriesLeft - 1));
          }, 2000 * (5 - retriesLeft));
        });
      }
      return r;
    });
  }

  function getSpendConfig() {
    var card = document.querySelector('[data-spend-gift-card]');
    if (!card || card.getAttribute('data-spend-enabled') !== 'true') return null;
    var qualifyingIds = {};
    String(card.getAttribute('data-spend-qualifying-ids') || '')
      .split(',')
      .forEach(function (id) {
        id = String(id || '').trim();
        if (id) qualifyingIds[id] = true;
      });
    return {
      threshold: parseInt(card.getAttribute('data-spend-threshold') || '0', 10) || 0,
      claimLimit: parseInt(card.getAttribute('data-spend-claim-limit') || '1', 10) || 1,
      remaining: parseInt(card.getAttribute('data-spend-remaining') || '0', 10) || 0,
      qualifyingIds: qualifyingIds,
      hasQualifyingFilter: Object.keys(qualifyingIds).length > 0
    };
  }

  function isSpendGiftItem(item) {
    return !!(item && item.properties && item.properties._promo_type === SPEND_PROMO.type);
  }

  function isSpendQualifyingItem(item, cfg) {
    if (!item || !cfg) return false;
    if (isSpendGiftItem(item)) return false;
    if (item.properties && item.properties._promo_type === 'buy3_gift') return false;
    if (item.product_type === 'shipping-protection') return false;
    if (!cfg.hasQualifyingFilter) return false;
    return !!cfg.qualifyingIds[String(item.product_id)];
  }

  function calcSpendEligibleTotal(items, cfg) {
    var total = 0;
    (items || []).forEach(function (item) {
      if (isSpendQualifyingItem(item, cfg)) {
        total += item.final_line_price || 0;
      }
    });
    return total;
  }

  function getSpendGiftKeys(items) {
    return (items || []).filter(isSpendGiftItem).map(function (item) { return item.key; });
  }

  function trySpendRefreshWhenIdle() {
    if (!spendCartNeedsRefresh || spendQueueRunning || spendAddQueue.length > 0 || spendRemoving) return;
    if (spendRefreshTimer) clearTimeout(spendRefreshTimer);
    spendRefreshTimer = setTimeout(function () {
      spendRefreshTimer = null;
      spendCartNeedsRefresh = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, SPEND_REFRESH_DELAY);
  }

  function removeSpendGiftsIfBelowThreshold(items) {
    var cfg = getSpendConfig();
    if (!cfg || !cfg.threshold || spendRemoving) return Promise.resolve(false);

    var eligible = calcSpendEligibleTotal(items, cfg);
    if (eligible >= cfg.threshold) return Promise.resolve(false);

    var keys = getSpendGiftKeys(items);
    if (!keys.length) return Promise.resolve(false);

    spendRemoving = true;
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });

    return spendFetchWithRetry('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('spend gift remove failed');
      spendCartNeedsRefresh = true;
      return true;
    }).catch(function () {
      return false;
    }).finally(function () {
      spendRemoving = false;
      trySpendRefreshWhenIdle();
    });
  }

  function addSpendGiftToCart(variantId) {
    return spendFetchWithRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: {
          '_promo_type': SPEND_PROMO.type,
          '_promo_campaign': SPEND_PROMO.campaign
        }
      })
    }).then(function (r) {
      if (r.status === 429) return 'rate_limited';
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function runSpendAddQueue() {
    if (spendQueueRunning || !spendAddQueue.length) return;
    spendQueueRunning = true;

    var gapWait = Math.max(0, SPEND_ADD_GAP - (Date.now() - spendLastAddAt));
    setTimeout(function () {
      var job = spendAddQueue.shift();
      if (!job) {
        spendQueueRunning = false;
        return;
      }

      var btn = job.btn;
      var origText = job.origText;
      var cfg = getSpendConfig();
      if (!cfg || cfg.remaining <= 0) {
        btn.textContent = origText;
        btn.disabled = false;
        delete btn.dataset.spendQueued;
        spendQueueRunning = false;
        spendAddQueue = [];
        var modalEarly = document.getElementById('spend-gift-select-modal');
        if (modalEarly && typeof modalEarly.hide === 'function') modalEarly.hide();
        return;
      }

      btn.textContent = '...';

      addSpendGiftToCart(job.variantId)
        .then(function (result) {
          if (result === 'rate_limited') {
            spendAddQueue.unshift(job);
            btn.textContent = 'Wait...';
            return false;
          }
          spendCartNeedsRefresh = true;
          btn.textContent = '✓ ADDED';
          delete btn.dataset.spendQueued;

          var card = document.querySelector('[data-spend-gift-card]');
          if (card) {
            var nextRemaining = Math.max(0, (parseInt(card.getAttribute('data-spend-remaining') || '0', 10) || 0) - 1);
            card.setAttribute('data-spend-remaining', String(nextRemaining));
          }

          var modal = document.getElementById('spend-gift-select-modal');
          if (modal && typeof modal.hide === 'function') modal.hide();

          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
          return true;
        })
        .catch(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.spendQueued;
        })
        .finally(function () {
          spendLastAddAt = Date.now();
          spendQueueRunning = false;
          var nextDelay = btn.textContent === 'Wait...' ? SPEND_RATE_LIMIT_WAIT : 0;
          setTimeout(function () {
            runSpendAddQueue();
            trySpendRefreshWhenIdle();
          }, nextDelay);
        });
    }, gapWait);
  }

  function initSpendProductForms() {
    if (window.__fgGiftModalUI && typeof window.__fgGiftModalUI.initProductForms === 'function') {
      window.__fgGiftModalUI.initProductForms('#spend-gift-select-modal');
    }
  }

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'spend-gift-select-modal') {
      if (window.__fgGiftModalUI && typeof window.__fgGiftModalUI.initColorDots === 'function') {
        window.__fgGiftModalUI.initColorDots();
      }
      initSpendProductForms();
    }
  });

  document.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('#spend-gift-select-modal .buy3-gift-modal-product__btn');
    if (chooseBtn && !chooseBtn.disabled && chooseBtn.dataset.spendQueued !== '1') {
      var form = chooseBtn.closest('.buy3-gift-product-form');
      if (!form) return;
      var variantId = form.querySelector('.buy3-gift-variant-id').value;
      if (!variantId) return;

      var cfg = getSpendConfig();
      if (!cfg || cfg.remaining <= 0) {
        var modalClosed = document.getElementById('spend-gift-select-modal');
        if (modalClosed && typeof modalClosed.hide === 'function') modalClosed.hide();
        return;
      }

      chooseBtn.disabled = true;
      chooseBtn.dataset.spendQueued = '1';
      var origText = chooseBtn.textContent.trim();
      chooseBtn.textContent = spendQueueRunning || spendAddQueue.length ? 'Queued' : '...';

      spendAddQueue.push({ btn: chooseBtn, origText: origText, variantId: variantId });
      runSpendAddQueue();
    }
  });

  document.addEventListener('cart:change', function (e) {
    if (!e.detail || !e.detail.cart || !e.detail.cart.items) return;
    removeSpendGiftsIfBelowThreshold(e.detail.cart.items);
  });

  try {
    var storedSpend = JSON.parse(localStorage.getItem('theme:cart-items') || '[]');
    if (storedSpend.length) removeSpendGiftsIfBelowThreshold(storedSpend);
  } catch (err) {}

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (cart && cart.items) removeSpendGiftsIfBelowThreshold(cart.items);
    })
    .catch(function () {});
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (!root || root.dataset.lookReady === 'true') return;
    root.dataset.lookReady = 'true';

    root.addEventListener('click', function (event) {
      const opener = event.target.closest('[data-look-quick-buy]');
      if (!opener || !root.contains(opener)) return;
      event.preventDefault();
      event.stopPropagation();
      const modalId = opener.getAttribute('data-look-quick-buy');
      const modal = modalId ? document.getElementById(modalId) : null;
      if (modal && typeof modal.show === 'function') {
        Promise.resolve(modal.show()).catch(function () {});
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-look-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-autumn-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.getAttribute('data-bound') === 'true') return;
      root.setAttribute('data-bound', 'true');

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-autumn-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-autumn-panel]'));
      if (!tabs.length) return;

      function select(tab) {
        var id = tab.getAttribute('aria-controls');
        tabs.forEach(function (button) {
          var selected = button === tab;
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
          button.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(function (panel) {
          if (panel.id === id) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }

      root.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-autumn-tab]');
        if (!tab || !root.contains(tab)) return;
        select(tab);
      });

      root.addEventListener('keydown', function (event) {
        var current = event.target.closest('[data-autumn-tab]');
        if (!current || !root.contains(current)) return;
        var index = tabs.indexOf(current);
        if (index < 0) return;
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else return;
        event.preventDefault();
        tabs[nextIndex].focus();
        select(tabs[nextIndex]);
      });
    }

    function boot(event) {
      var scope = event && event.target ? event.target : document;
      if (scope.querySelectorAll) scope.querySelectorAll('[data-wedding-autumn]').forEach(init);
      if (scope.matches && scope.matches('[data-wedding-autumn]')) init(scope);
    }

    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-best-seller"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP_QUERY = '(min-width: 768px)';

    function isDesktop() {
      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function update(track, bar) {
      var max = track.scrollWidth - track.clientWidth;
      var viewRatio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var width = Math.min(Math.max(viewRatio * 100, 8), 100);
      var left = max <= 1 ? 0 : (track.scrollLeft / max) * (100 - width);
      bar.style.width = width + '%';
      bar.style.left = left + '%';
      var progress = bar.parentElement;
      if (progress && progress.getAttribute('role') === 'scrollbar') {
        progress.setAttribute('aria-valuenow', String(Math.round(max <= 1 ? 0 : (track.scrollLeft / max) * 100)));
      }
    }

    function enableDesktopScrollbar(track, progress, bar) {
      progress.removeAttribute('aria-hidden');
      progress.setAttribute('role', 'scrollbar');
      progress.setAttribute('aria-orientation', 'horizontal');
      progress.setAttribute('aria-valuemin', '0');
      progress.setAttribute('aria-valuemax', '100');
      progress.tabIndex = 0;
      if (progress.getAttribute('data-drag') === 'true') return;
      progress.setAttribute('data-drag', 'true');

      var dragging = false;
      var grab = 0;

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function thumbWidth() {
        return bar.getBoundingClientRect().width;
      }

      function scrollFromClientX(clientX) {
        var rect = progress.getBoundingClientRect();
        var usable = rect.width - thumbWidth();
        var max = maxScroll();
        if (usable <= 0 || max <= 0) return;
        var ratio = (clientX - rect.left - grab) / usable;
        ratio = Math.min(Math.max(ratio, 0), 1);
        track.scrollLeft = ratio * max;
      }

      function snapTrack() {
        var card = track.querySelector('.product-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        var max = maxScroll();
        if (step <= 0 || max <= 0) return;
        var left = Math.round(track.scrollLeft / step) * step;
        track.scrollTo({ left: Math.min(Math.max(left, 0), max), behavior: 'auto' });
      }

      progress.addEventListener('pointerdown', function (event) {
        if (!isDesktop() || event.button !== 0) return;
        if (maxScroll() <= 1) return;
        var barRect = bar.getBoundingClientRect();
        var onThumb = event.clientX >= barRect.left && event.clientX <= barRect.right;
        grab = onThumb ? event.clientX - barRect.left : thumbWidth() / 2;
        dragging = true;
        progress.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        try {
          progress.setPointerCapture(event.pointerId);
        } catch (error) {}
        scrollFromClientX(event.clientX);
        event.preventDefault();
      });

      progress.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        scrollFromClientX(event.clientX);
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        progress.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
        snapTrack();
        if (progress.hasPointerCapture && progress.hasPointerCapture(event.pointerId)) {
          progress.releasePointerCapture(event.pointerId);
        }
      }

      progress.addEventListener('pointerup', endDrag);
      progress.addEventListener('pointercancel', endDrag);
      progress.addEventListener('keydown', function (event) {
        if (!isDesktop()) return;
        var max = maxScroll();
        if (max <= 1) return;
        var card = track.querySelector('.product-card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card ? card.getBoundingClientRect().width + gap : max / 4;
        var next = track.scrollLeft;
        if (event.key === 'ArrowRight') next += step;
        else if (event.key === 'ArrowLeft') next -= step;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = max;
        else return;
        event.preventDefault();
        track.scrollTo({ left: Math.min(Math.max(next, 0), max), behavior: 'auto' });
      });
    }

    function disableDesktopScrollbar(progress) {
      progress.setAttribute('aria-hidden', 'true');
      progress.removeAttribute('role');
      progress.removeAttribute('aria-orientation');
      progress.removeAttribute('aria-valuemin');
      progress.removeAttribute('aria-valuemax');
      progress.removeAttribute('aria-valuenow');
      progress.removeAttribute('tabindex');
    }

    function syncScrollbar(track, progress, bar) {
      if (isDesktop()) enableDesktopScrollbar(track, progress, bar);
      else disableDesktopScrollbar(progress);
      update(track, bar);
    }

    function init(root) {
      if (root.getAttribute('data-bound') === 'true') return;
      root.setAttribute('data-bound', 'true');
      var track = root.querySelector('[data-best-track]');
      var progress = root.querySelector('[data-best-progress]');
      var bar = root.querySelector('[data-best-progress-bar]');
      if (!track || !progress || !bar) return;

      track.addEventListener('scroll', function () { update(track, bar); }, { passive: true });
      syncScrollbar(track, progress, bar);
      root.__weddingBestSync = function () { syncScrollbar(track, progress, bar); };
    }

    if (!window.__weddingBestResize) {
      window.__weddingBestResize = true;
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-wedding-best]').forEach(function (root) {
          if (root.__weddingBestSync) root.__weddingBestSync();
        });
      });
    }

    function boot(event) {
      var scope = event && event.target ? event.target : document;
      var nodes = scope.querySelectorAll ? scope.querySelectorAll('[data-wedding-best]') : [];
      nodes.forEach(init);
      if (scope.matches && scope.matches('[data-wedding-best]')) init(scope);
    }

    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-feature-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var placers = [];

    function init(root) {
      if (root.getAttribute('data-bound') === 'true') return;
      var rows = root.querySelectorAll('[data-feature-row]');
      var prev = root.querySelector('[data-feature-prev]');
      var next = root.querySelector('[data-feature-next]');
      if (!rows.length || !prev || !next) return;
      root.setAttribute('data-bound', 'true');

      var index = 0;
      rows.forEach(function (row, i) {
        if (row.classList.contains('is-active')) index = i;
      });

      function show(nextIndex) {
        index = (nextIndex + rows.length) % rows.length;
        rows.forEach(function (row, i) {
          row.classList.toggle('is-active', i === index);
        });
        placeArrows();
      }

      function placeArrows() {
        if (!root.isConnected || window.matchMedia('(min-width: 768px)').matches) return;
        var media = root.querySelector('.wedding-feature__row.is-active .wedding-feature__media');
        if (!media) return;
        var rootRect = root.getBoundingClientRect();
        var mediaRect = media.getBoundingClientRect();
        var top = mediaRect.top - rootRect.top + mediaRect.height / 2;
        prev.style.top = top + 'px';
        next.style.top = top + 'px';
      }

      prev.addEventListener('click', function () { show(index - 1); });
      next.addEventListener('click', function () { show(index + 1); });
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', placeArrows);
      });
      placers.push(placeArrows);
      window.requestAnimationFrame(placeArrows);
    }

    function boot() {
      document.querySelectorAll('[data-wedding-feature]').forEach(init);
    }

    window.addEventListener('resize', function () {
      placers.forEach(function (place) { place(); });
    });
    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__weddingHeroScroll) return;
    window.__weddingHeroScroll = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wedding-scroll-next]');
      if (!button) return;
      var section = button.closest('.shopify-section');
      var next = section && section.nextElementSibling;
      if (!next) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_QUERY = '(max-width: 767px)';

    function durationOf(root) {
      var raw = parseInt(root.getAttribute('data-duration'), 10);
      return raw > 0 ? raw : 400;
    }

    function cardLimit() {
      return window.matchMedia(MOBILE_QUERY).matches ? 5 : 8;
    }

    function visibleCount(root) {
      if (window.matchMedia(MOBILE_QUERY).matches) return cardLimit();
      var desktop = parseInt(root.getAttribute('data-display-count'), 10) || 4;
      return Math.min(desktop, cardLimit());
    }

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function init(root) {
      if (root.getAttribute('data-bound') === 'true') return;
      root.setAttribute('data-bound', 'true');

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-review-item]'));
      if (!items.length) return;

      var queue = [];
      var busy = false;
      var mode = window.matchMedia(MOBILE_QUERY).matches ? 'mobile' : 'desktop';

      function paint() {
        var active = {};
        queue.forEach(function (index) { active[index] = true; });
        items.forEach(function (item, index) {
          item.classList.toggle('is-active', !!active[index]);
          var bubble = item.querySelector('[data-review-bubble]');
          if (bubble) bubble.classList.remove('is-leaving', 'is-entering');
        });
        root.querySelectorAll('[data-review-switch]').forEach(function (button) {
          var index = parseInt(button.getAttribute('data-review-index'), 10);
          var on = !!active[index];
          button.classList.toggle('is-current', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function resetQueue() {
        var count = Math.min(visibleCount(root), items.length, cardLimit());
        queue = [];
        for (var i = 0; i < count; i++) queue.push(i);
        busy = false;
        paint();
      }

      function finishSwap(enteringIndex) {
        queue.shift();
        queue.push(enteringIndex);
        paint();
        var bubble = items[enteringIndex].querySelector('[data-review-bubble]');
        if (!bubble || reducedMotion()) {
          busy = false;
          return;
        }
        bubble.classList.add('is-entering');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            bubble.classList.remove('is-entering');
            window.setTimeout(function () { busy = false; }, durationOf(root));
          });
        });
      }

      function swapTo(index) {
        if (busy || queue.indexOf(index) !== -1) return;
        var leavingBubble = items[queue[0]].querySelector('[data-review-bubble]');
        busy = true;
        if (!leavingBubble || reducedMotion()) {
          finishSwap(index);
          return;
        }
        leavingBubble.classList.add('is-leaving');
        window.setTimeout(function () { finishSwap(index); }, durationOf(root));
      }

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-review-open]');
        if (!trigger || !root.contains(trigger)) return;
        var index = parseInt(trigger.getAttribute('data-review-index'), 10);
        if (isNaN(index) || index >= cardLimit() || queue.indexOf(index) !== -1) return;
        swapTo(index);
      });

      resetQueue();

      var media = window.matchMedia(MOBILE_QUERY);
      function onMode() {
        var next = media.matches ? 'mobile' : 'desktop';
        if (next === mode) return;
        mode = next;
        resetQueue();
      }
      if (media.addEventListener) media.addEventListener('change', onMode);
      else if (media.addListener) media.addListener(onMode);
    }

    function boot(event) {
      var scope = event && event.target ? event.target : document;
      if (scope.querySelectorAll) scope.querySelectorAll('[data-wedding-reviews]').forEach(init);
      if (scope.matches && scope.matches('[data-wedding-reviews]')) init(scope);
    }

    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var states = [];

    function measure(track) {
      var items = track.querySelectorAll('[data-ugc-item]');
      var count = items.length / 2;
      if (count < 1) return null;
      var first = items[0];
      var clone = items[count];
      if (!clone) return null;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      var width = first.getBoundingClientRect().width;
      var stride = clone.offsetLeft - first.offsetLeft;
      if (width < 1 || stride < 2) return null;
      return {
        items: items,
        count: count,
        gap: gap,
        stride: stride,
        width: width
      };
    }

    function itemMid(el) {
      return el.offsetLeft + el.getBoundingClientRect().width / 2;
    }

    function setupLoop(track) {
      if (track.getAttribute('data-loop') === 'true') return;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a').forEach(function (link) {
          link.tabIndex = -1;
        });
        track.appendChild(clone);
      });
      track.setAttribute('data-loop', 'true');
    }

    function init(root) {
      if (root.getAttribute('data-bound') === 'true') return;
      var track = root.querySelector('[data-ugc-track]');
      var prev = root.querySelector('[data-ugc-prev]');
      var next = root.querySelector('[data-ugc-next]');
      if (!track || !track.children.length) return;
      root.setAttribute('data-bound', 'true');
      setupLoop(track);

      var index = 0;
      var lock = false;
      var animating = false;
      var animToken = 0;
      var paused = false;
      var snapTimer = 0;
      var seenTrack = 0;
      var retries = 0;
      var state = { root: root, frameId: 0, place: null };

      function metrics() {
        return measure(track);
      }

      function wrapped(value, stride) {
        return ((value % stride) + stride) % stride;
      }

      function nearest() {
        var m = metrics();
        if (!m) return null;
        var current = track.scrollLeft;
        var best = null;
        var i;
        for (i = 0; i < m.count; i += 1) {
          var mid = itemMid(m.items[i]);
          [mid - m.stride, mid, mid + m.stride].forEach(function (pos) {
            var delta = pos - current;
            if (!best || Math.abs(delta) < Math.abs(best.delta)) {
              best = { n: (i + 1) % m.count, delta: delta, m: m };
            }
          });
        }
        return best;
      }

      function wrap() {
        if (lock) return;
        var m = metrics();
        if (!m) return;
        var left = track.scrollLeft;
        if (left >= m.stride) {
          lock = true;
          track.scrollLeft = left - m.stride;
          lock = false;
        } else if (left <= 0) {
          lock = true;
          track.scrollLeft = left + m.stride;
          lock = false;
        }
      }

      function animateBy(delta) {
        var token = ++animToken;
        var start = track.scrollLeft;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduce ? 0 : 380;
        var t0 = 0;
        animating = true;
        window.clearTimeout(snapTimer);

        function frame(now) {
          if (token !== animToken) return;
          if (!t0) t0 = now;
          var progress = duration === 0 ? 1 : Math.min(1, (now - t0) / duration);
          var eased = 1 - Math.pow(1 - progress, 3);
          track.scrollLeft = start + delta * eased;
          if (progress < 1) {
            window.requestAnimationFrame(frame);
          } else {
            animating = false;
            var near = nearest();
            if (near) index = near.n;
          }
        }

        window.requestAnimationFrame(frame);
      }

      function go(direction) {
        var near = nearest();
        if (!near) return;
        var m = near.m;
        var count = m.count;
        var normalized = ((near.n + direction) % count + count) % count;
        var prev = (normalized - 1 + count) % count;
        var mid = itemMid(m.items[prev]);
        var current = track.scrollLeft;
        var chosen = null;
        [mid - m.stride, mid, mid + m.stride].forEach(function (pos) {
          var delta = pos - current;
          if (direction > 0 && delta > 0.5 && (chosen === null || delta < chosen)) chosen = delta;
          if (direction < 0 && delta < -0.5 && (chosen === null || delta > chosen)) chosen = delta;
        });
        if (chosen === null) chosen = direction * (m.items[normalized].getBoundingClientRect().width + m.gap);
        index = normalized;
        animateBy(chosen);
      }

      function snap() {
        if (animating || root.getAttribute('data-autoplay') === 'true') return;
        var near = nearest();
        if (!near || Math.abs(near.delta) < 1) {
          if (near) index = near.n;
          return;
        }
        animateBy(near.delta);
      }

      function place() {
        var m = metrics();
        if (!m) {
          if (retries < 30) {
            retries += 1;
            window.requestAnimationFrame(place);
          }
          return;
        }
        retries = 0;
        var trackW = track.clientWidth;
        if (Math.abs(trackW - seenTrack) < 0.5 && track.getAttribute('data-placed') === 'true') return;
        seenTrack = trackW;
        var prev = (index - 1 + m.count) % m.count;
        var pos = itemMid(m.items[prev]);
        pos = wrapped(pos, m.stride);
        if (pos <= 0) pos = itemMid(m.items[m.count - 1]);
        lock = true;
        track.scrollLeft = pos;
        lock = false;
        track.setAttribute('data-placed', 'true');
      }

      state.place = place;

      track.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          track.removeAttribute('data-placed');
          seenTrack = 0;
          place();
        });
      });

      track.addEventListener('scroll', function () {
        wrap();
        if (animating || lock) return;
        window.clearTimeout(snapTimer);
        snapTimer = window.setTimeout(snap, 120);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(1);
        }
      });

      window.requestAnimationFrame(place);
      states.push(state);

      if (root.getAttribute('data-autoplay') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var seconds = parseInt(root.getAttribute('data-speed'), 10) || 4;
      var last = 0;

      function tick(now) {
        if (!last) last = now;
        var m = metrics();
        if (m && !paused && !animating) {
          track.scrollLeft += ((m.stride / m.count) / (seconds * 1000)) * (now - last);
        }
        last = now;
        state.frameId = window.requestAnimationFrame(tick);
      }

      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) paused = false;
      });
      track.addEventListener('pointerdown', function () { paused = true; });
      track.addEventListener('pointerup', function () { paused = false; });
      track.addEventListener('pointercancel', function () { paused = false; });
      state.frameId = window.requestAnimationFrame(tick);
    }

    function boot() {
      document.querySelectorAll('[data-wedding-ugc]').forEach(init);
    }

    window.addEventListener('resize', function () {
      states.forEach(function (state) {
        if (state.root.isConnected) state.place();
      });
    });

    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function (event) {
      states = states.filter(function (state) {
        var remove = event.target.contains(state.root);
        if (remove) window.cancelAnimationFrame(state.frameId);
        return state.root.isConnected && !remove;
      });
    });

    boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
